import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import cond from 'lodash/fp/cond';
import isString from 'lodash/fp/isString';
import isNumber from 'lodash/fp/isNumber';
import stubTrue from 'lodash/fp/stubTrue';
import constant from 'lodash/fp/constant';
import identity from 'lodash/fp/identity';
import ms from 'ms';
import pipeP from './utils/pipeP';

var cleanDisabled = function cleanDisabled() {
  return function (rules) {
    return rules.filter(function (rule) {
      return !rule.disabled;
    });
  };
};

var validToTS = cond([[function (x) {
  return x instanceof Date;
}, function (x) {
  return x.getTime();
}], [isString, function (x) {
  return new Date(x).getTime();
}], [isNumber, identity], [stubTrue, constant(undefined)]]);

var validInRule = function validInRule(_ref) {
  var validFrom = _ref.validFrom,
      validTo = _ref.validTo,
      rest = _objectWithoutProperties(_ref, ["validFrom", "validTo"]);

  return _extends({}, rest, {
    validFrom: validToTS(validFrom),
    validTo: validToTS(validTo)
  });
};

var validTSEnsure = function validTSEnsure(rules) {
  return rules.map(validInRule);
};

var cleanEnded = function cleanEnded(now) {
  return function (rules) {
    return rules.filter(function (r) {
      return !r.validTo || r.validTo && now <= r.validTo;
    });
  };
};

var cleanFuture = function cleanFuture(future) {
  return function (rules) {
    return rules.filter(function (r) {
      return !r.validFrom || r.validFrom && future > r.validFrom;
    });
  };
};

var constraintsForValid = function constraintsForValid(now) {
  return function (rules) {
    return rules.map(function (_ref2) {
      var _ref2$targets = _ref2.targets,
          targets = _ref2$targets === void 0 ? [] : _ref2$targets,
          validFrom = _ref2.validFrom,
          validTo = _ref2.validTo,
          restR = _objectWithoutProperties(_ref2, ["targets", "validFrom", "validTo"]);

      return _extends({}, restR, {
        validFrom: validFrom,
        validTo: validTo,
        targets: !validFrom && !validTo ? targets : (targets.length === 0 ? [{
          triggers: [],
          constraints: []
        }] : targets).map(function (_ref3) {
          var _ref3$triggers = _ref3.triggers,
              triggers = _ref3$triggers === void 0 ? [] : _ref3$triggers,
              _ref3$constraints = _ref3.constraints,
              constraints = _ref3$constraints === void 0 ? [] : _ref3$constraints,
              restT = _objectWithoutProperties(_ref3, ["triggers", "constraints"]);

          return _extends({}, restT, {
            triggers: triggers,
            constraints: [].concat(_toConsumableArray(validFrom && validFrom > now ? [['ruleValidFrom', [validFrom]]] : []), _toConsumableArray(validTo ? [['ruleValidTo', [validTo]]] : []), _toConsumableArray(constraints))
          });
        })
      });
    });
  };
};
/**
 * Clean...
 */


export default function compileCleanRules(options) {
  var _ref4 = options || {},
      _ref4$validTreshold = _ref4.validTreshold,
      validTresholdOption = _ref4$validTreshold === void 0 ? '1d' : _ref4$validTreshold;

  var validTreshold = isString(validTresholdOption) ? ms(validTresholdOption) : validTresholdOption * 1000;
  return /*#__PURE__*/function () {
    var _cleanRules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rules) {
      var now, nextRules;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              now = Date.now();
              _context.next = 3;
              return pipeP(cleanDisabled(), validTSEnsure, cleanEnded(now), cleanFuture(now + validTreshold), constraintsForValid(now))(rules);

            case 3:
              nextRules = _context.sent;
              return _context.abrupt("return", nextRules);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function cleanRules(_x) {
      return _cleanRules.apply(this, arguments);
    }

    return cleanRules;
  }();
}